import httpClient from '@/api/http-client';
import getFormData from '@/util/form-data';

const endpoint = 'api/permits-import';

const permitsImportService = {
  upload: (payload) => {
    const formData = getFormData(payload);

    return httpClient.post(`${endpoint}`, formData);
  },
};

export default permitsImportService;
